export default __webpack_public_path__ + "static/media/amazon-prime-icon.23e4f428.svg";